export default __webpack_public_path__ + "20743a8ee25d5500e23e8e7f1f440cee.png";